import moment from "moment";
export default {
  show() {
    console.log("show-test");
  },
  uniArray(arr, value) {
    if (arr.includes(value)) {
      let index = arr.findIndex(valueIndex => {
        return value == valueIndex;
      });
      arr.splice(index, 1);
    } else {
      arr.push(value);
    }
    return arr;
  },

  otherFee: {
    thai: {
      pending_approval: "รอตรวจสอบ",
      pending_receipt: "ไม่ได้ชำระ",
      received: "ชำระเงินแล้ว"
    }
  },
  orderCreditCheck: {
    thai: {
      booked: "รอจัดส่ง",
      cancelled: "ยกเลิก",
      pending_receipt: "ไม่ได้ชำระ",
      received: "ชำระแล้ว"
    }
  },

  orderStatus: {
    thai: {
      all: "ออเดอร์ทั้งหมด",
      booked: "รอจัดส่ง",
      "on-delivery": "ระหว่างจัดส่ง",
      "delivery-success": "ส่งสำเร็จ",
      "on-return": "กำลังตีกลับ",
      "return-success": "ตีกลับสำเร็จ",
      "on-claim": "เคลม",
      "claim-success": "เคลมสำเร็จ",
      cancel: "ยกเลิก",
      cancelled: "ยกเลิก",
      "delivery-failed": "ระหว่างจัดส่ง",
      pickup: "ระหว่างจัดส่ง"
      //   "delivery-failed":"ระหว่างจัดส่ง",
      //   "wait-transfer":"รอโอน",
      //   "transfer-success":"โอนแล้ว",
      //   "on-return-back":"ตีกลับ"
    }
  },

  orderCredit: {
    thai: {
      approved: "ชำระแล้ว",
      pending: "ไม่ได้ชำระ",
      cancelled: "ยกเลิก"
    }
  },

  checkDecimalShow(value) {
    if (value % 1 != 0) {
      return value;
    } else {
      return parseInt(value);
    }
  },
  getFirstDayOfMonth() {
    let dateToken = new Date();
    let year = dateToken.getFullYear();
    let month = dateToken.getMonth();
    return new Date(year, month, 1);
  },

  hasWhiteSpace(s) {
    return /\s/.test(s);
  },
  preventleadingspace(e) {
    // only prevent the keypress if the value is blank
    if (!e.target.value) e.preventdefault();
    // otherwise, if the leading character is a space, remove all leading white-space
    else if (e.target.value[0] == " ") e.target.value = e.target.value.replace(/^\s*/, "");
  },
  cutFileName(value) {
    value = value.split("attachment;")[1];
    value = value.split("=")[1];
    value = value.split('"')[1];
    return value;
  },
  calcDate(date, days) {
    var result = date; // not instatiated with date!!! DANGER
    result.setDate(date.getDate() - days);
    return result;
  },
  monthTh: ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."],
  calcDatePlus(date, days) {
    var result = date; // not instatiated with date!!! DANGER
    result.setDate(date.getDate() + days);
    return result;
  },
  calcdateBetweenDay(date1 = new Date(), date2 = new Date()) {
    let Difference_In_Time = date1.getTime() - date2.getTime();
    let Difference_In_Days = Math.round(Difference_In_Time / (1000 * 3600 * 24));
    return Difference_In_Days;
  },
  PermissionFlag(key, keyadvance) {
    if (key) {
      let account = JSON.parse(localStorage.getItem("auth.currentUser"))?.user?.id?.account_child_link?.access_level;
      if (account) {
        if (account[key]) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      false;
    }
  },

  checkStatusRequest(response) {
    return response && response.status === 200;
  },

  colorRocket() {
    if (process.env.VUE_APP_PROVIDER == "beemove") {
      return "#fcac00";
    } else {
      return "#9239d3";
    }
  },
  imageTheme() {
    return require(`@/assets/images/${process.env.VUE_APP_PROVIDER}/logo.png`);
  },
  imageMiniTab() {
    return require(`@/assets/images/${process.env.VUE_APP_PROVIDER}/mini.png`);
  }
};
